








































import { split } from "lodash";
import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class CategoryPathsViewer extends Vue {
  @Prop() private categoryPaths!: string[];
  @Provide("$_") $_: any;

  categoryTrees: {} = {};
  expandedCategoryPaths: string[] = [];

  constructSubcategories(categoryPaths: string[]) {
    const paths = categoryPaths.filter((p) => p.split(" > ").length >= 2);
    const groupedBySubcategory = this.$_.groupBy(
      paths,
      (p) => p.split(" > ")[1]
    );
    return this.$_.mapValues(groupedBySubcategory, (paths) =>
      paths
        .filter((p) => p.split(" > ").length === 3)
        .map((p) => p.split(" > ")[2])
    );
  }

  categories() {
    return Object.keys(this.categoryTrees);
  }

  subcategories(category) {
    return Object.keys(this.categoryTrees[category]);
  }

  leaves(category, subcategory) {
    return this.categoryTrees[category][subcategory];
  }

  onCategoryClicked(e, category: string) {
    if (this.expandedCategoryPaths.indexOf(category) < 0)
      this.expandedCategoryPaths = [...this.expandedCategoryPaths, category];
    else {
      this.expandedCategoryPaths = this.expandedCategoryPaths.filter(
        (p) => !p.startsWith(category)
      );
    }
  }

  onSubcategoryClicked(e, category, subCategory) {
    const categoryPath = `${category} > ${subCategory}`;
    if (this.expandedCategoryPaths.indexOf(categoryPath) < 0)
      this.expandedCategoryPaths = [
        ...this.expandedCategoryPaths,
        categoryPath,
      ];
    else
      this.expandedCategoryPaths = this.expandedCategoryPaths.filter(
        (p) => !p.startsWith(categoryPath)
      );
  }

  isExpanded(categoryPath) {
    return this.expandedCategoryPaths.includes(categoryPath);
  }

  mounted() {
    const categoryToCategoryPaths = this.$_.groupBy(
      this.categoryPaths,
      (path) => path.split(" > ")[0]
    );
    this.categoryTrees = this.$_.mapValues(categoryToCategoryPaths, (paths) =>
      this.constructSubcategories(paths)
    );
  }
}
